/* eslint-disable react/no-array-index-key */
import React, {
 useState, useRef, useEffect, memo
} from "react"
import ReactDOM from "react-dom"
import {
 Modal, Carousel, Button, Input
} from "antd"
import PropTypes from "prop-types"
import RVideo from "@/components/rc-video"
import { preloadImg, getYearMonth, isNumberInput } from "$utils"
import { UseIntentOrder } from "../intent-modal/order"
import { UseIntentBargain } from "../intent-modal/bargain"
import GifConsult from "~/img/buy/consult-tel-red.gif"

import "./styles.scss"

const GalleryModal = (props) => {
  const bigSufix = "?imageMogr2/strip/quality/80/thumbnail/1200x/format/jpg"
  const sliderBig = useRef()
  const {
 onClose, currentPicNum, submitParams, otherParams
} = props
  const {
 basicInfo, tags, images, isVideoClick
} = otherParams
  const newcarPrice = basicInfo.newcar_price
  const [visible, setVisible] = useState(props.visible)
  const [bargainPrice, setBargainPrice] = useState()
  const imgs = images
  const prePic = () => {
    global.$rbl.push("car-detail_basicinformation-carimage-size0-left1_click")
    sliderBig?.current?.slick?.slickPrev()
  }
  const nextPic = () => {
    global.$rbl.push("car-detail_basicinformation-carimage-size0-right1_click")
    sliderBig?.current?.slick?.slickNext()
  }
  const goToPic = (num) => {
    sliderBig?.current?.slick.slickGoTo(num)
  }
  useEffect(() => {
    // 预加载前1张图
    imgs.length && preloadImg([`${imgs[0].img_url}${bigSufix}`])
    setTimeout(() => {
      goToPic(currentPicNum)
    }, 0)
  }, [])

  // 免费咨询
  const toConsult = () => {
    global.$rbl.push({
      event: "car-detail_detail-slider-zixun",
      content: {
        param: "咨询-PC-详情页-13"
      }
    })
    setVisible(false)
    onClose()
    const _submitParams = {
      ...submitParams,
      sub_product: "咨询",
      submit_sources: "咨询-PC-详情页-13"
    }
    new UseIntentOrder({
      intentType: "consult",
      submitParams: _submitParams,
      otherParams
    }).open()
  }

  // 砍价
  const toBargain = () => {
    global.$rbl.push({
      event: "car-detail_detail-slider-kanjia",
      content: {
        param: "砍价-PC-详情页-5"
      }
    })
    setVisible(false)
    onClose()
    const _submitParams = {
      ...submitParams,
      owner_price: `${basicInfo.price}`,
      price: bargainPrice,
      submit_sources: "砍价-PC-详情页-5"
    }
    new UseIntentBargain({ submitParams: _submitParams, otherParams }).open()
  }
  return (
    <Modal
      footer={null}
      centered
      visible={visible}
      width={1190}
      onCancel={() => {
        setVisible(false)
        onClose && onClose()
      }}
      bodyStyle={{ padding: "0px" }}
    >
      <div className="r-slider-big clearfix">
        <div
          className={`r-slider-big__main ${
            isVideoClick ? "black" : ""
          } clearfix`}
        >
          {isVideoClick ? (
            <>
              <RVideo
                autoplay
                config={{
                  // poster: '//img1.rrcimg.com/dist/pc/images/report-video.png',
                  src: basicInfo?.video_url,
                  width: 306
                }}
              />
            </>
          ) : (
            <>
              <Carousel lazyLoad dots={false} ref={sliderBig}>
                {imgs &&
                  imgs.map((img, index) => (
                    <div key={index} className="img-box">
                      <img
                        src={`${img.img_url}${bigSufix}`}
                        alt={img.anno}
                        onClick={() => {
                          global.$rbl.push("car-detail_detail_gallery")
                          nextPic()
                        }}
                      />
                      <div className="photo-num">
                        <i className="iconfont icon-pic" />
                        {`${index + 1}/${imgs.length}`}
                      </div>
                    </div>
                  ))}
              </Carousel>
              <div className="next" onClick={nextPic}>
                <i className="iconfont icon-left" />
              </div>
              <div className="pre" onClick={prePic}>
                <i className="iconfont icon-left" />
              </div>
            </>
          )}
        </div>
        <div className="r-slider-big__action">
          <h3 className="title">{basicInfo?.title}</h3>
          <ul className="feature clearfix">
            <li>{getYearMonth(basicInfo?.licensed_date)}</li>
            <li>{basicInfo?.mileage}万公里</li>
            <li>{basicInfo?.emission}</li>
          </ul>
          <ul className="tags clearfix">
            {tags &&
              tags.map(tag => (
                <li
                  className="tag"
                  key={tag.txt}
                  style={{ backgroundColor: tag.color }}
                >
                  {tag.txt}
                </li>
              ))}
          </ul>
          <div className="price">
            ￥{basicInfo?.price}
            <span className="word">万</span>
            <span className="newcar-price">
              新车价：<s>{newcarPrice}</s>万
            </span>
          </div>
          {!basicInfo?.sold && (
            <>
              <Button
                type="primary"
                className="consult-btn"
                onClick={toConsult}
              >
                <div className="consult-icon">
                  <img src={GifConsult} alt="咨询车况" />
                </div>
                咨询车况
              </Button>
              <div className="cut clearfix">
                <Input
                  className="cut-price-to"
                  placeholder="输入您的意向价"
                  suffix="万"
                  size="large"
                  value={bargainPrice}
                  onInput={(e) => {
                    if (isNumberInput(e.target.value)) {
                      setBargainPrice(e.target.value)
                    }
                  }}
                />
                <Button className="cut-btn" onClick={toBargain}>
                  砍价
                </Button>
              </div>
            </>
          )}
          {/* <div className="tel">
            <i className="tel-icon iconfont icon-call" />
            {phoneSource?.buyer}
          </div> */}
        </div>
      </div>
    </Modal>
  )
}

GalleryModal.propTypes = {
  visible: PropTypes.bool,
  currentPicNum: PropTypes.number,
  onClose: PropTypes.func,
  submitParams: PropTypes.object,
  otherParams: PropTypes.object
}

GalleryModal.defaultProps = {
  visible: false,
  currentPicNum: 0,
  onClose: null,
  submitParams: {},
  otherParams: {}
}

function mountAnywhere(Comp, root) {
  const div = document.createElement("div");
  (root || document.body).appendChild(div)
  // 向组件注入 onClose 方法，以便组件能调用关闭
  const Clone = React.cloneElement(Comp, {
    onClose: () => {
      ReactDOM.unmountComponentAtNode(div)
      div.parentNode.removeChild(div)
    }
  })
  ReactDOM.render(Clone, div)
  return div
}

export class UseGalleryModal {
  constructor(params) {
    this.visible = false
    this.ref = null
    this.submitParams = params.submitParams
    this.otherParams = params.otherParams
    this.currentPicNum = params.currentPicNum
  }

  open() {
    this.visible = true
    this.ref = mountAnywhere(
      <GalleryModal
        visible={this.visible}
        currentPicNum={this.currentPicNum}
        submitParams={this.submitParams}
        otherParams={this.otherParams}
      />
    )
    return this.ref
  }

  close() {
    this.visible = false
  }
}
export default memo(GalleryModal)
